import React from "react";
import { connect } from "react-redux";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { PlayCircle, RepeatOne } from "@mui/icons-material";
import { playPlaylistSongAtIndex } from "../../utils/amplitude-util";
import { setCurrentSong } from "../../store/actions/currentSongActoins";
function PlayLists({ playlists, setCurrentSongCommand }) {
  console.log("playlistcomponent", playlists);
  return (
    <List style={{ width: "100%" }}>
      {playlists
        ? Object.keys(playlists).map((playlistName) => (
            <ListItem>
              <ListItemText>{playlistName}</ListItemText>
              <ListItemIcon>
                <RepeatOne
                  style={{
                    color: "white",
                    paddingLeft: 15,
                    boxSizing: "content-box",
                  }}
                />
              </ListItemIcon>
              <ListItemIcon>
                <PlayCircle
                  style={{ color: "white" }}
                  onClick={() => {
                    setCurrentSongCommand(undefined);
                    playPlaylistSongAtIndex(0, playlistName);
                  }}
                />
              </ListItemIcon>
            </ListItem>
          ))
        : undefined}
    </List>
  );
}
const mapStateToProps = (state, ownProps) => {
  return {
    playlists: state.playLists,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addPlayLIst: (name) => {
      dispatch({ type: "ADD_PLAYLIST", payload: { playlistName: name, name } });
    },
    setCurrentSongCommand: (song) => {
      dispatch(setCurrentSong({ ...song, playing: true }));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PlayLists);
